export const formatMessageTime = (timestamp, options = {}) => {
  const { includeTimeWithYesterday = false } = options;

  if (!timestamp) return '';

  const messageDate = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date();

  yesterday.setDate(today.getDate() - 1);

  const timeString = messageDate.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  if (messageDate.toDateString() === today.toDateString()) {
    return timeString;
  }

  if (messageDate.toDateString() === yesterday.toDateString()) {
    return includeTimeWithYesterday ? `Yesterday, ${timeString}` : 'Yesterday';
  }

  const day = String(messageDate.getDate()).padStart(2, '0');
  const month = String(messageDate.getMonth() + 1).padStart(2, '0');
  const year = String(messageDate.getFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
};
